import TSUtils from "../../../utils/helpers/TSUtils";

export const recomputeEffectiveByAvgBasket = (
  value: number | undefined,
  avgBasket: number | undefined,
  multiplier: number | undefined,
  currency: string,
  subUnits: number
) => {
  if (!value || !avgBasket || !multiplier) {
    return TSUtils.formatAmountUsingIntl(0, subUnits, currency);
  }

  // avgBasket is in currency units, multiply by subUnits to convert to sub-units for formatting
  return TSUtils.formatAmountUsingIntl(
    value * avgBasket * multiplier * subUnits,
    subUnits,
    currency
  );
};
